
import TransferDomain from "./TransferDomain.vue";

export default {
  components: {
    TransferDomain,
  },
};
